<template>
    <div>
        
        <!-- Encabezado de la Aplicación -->
        <div class="appHeader no-border transparent position-absolute">
            <div class="left">
                <a href="#" class="headerButton goBack">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle"></div>
            <div class="right">
            </div>
        </div>
        <!-- * Encabezado de la Aplicación -->

        <!-- Cápsula de la Aplicación -->
        <div id="appCapsule">

            <div class="section mt-2 text-center">
                <h1>Cambiar contraseña</h1>
                <h4>Use el siguiente formulario para actualizar su contraseña</h4>
            </div>
            <div class="section">
                <p v-if="errors.length">
                    <b>Por favor, corrija el(los) siguiente(s) error(es):</b>
                    <!-- <ul><li v-for="(error, e) in errors" v-bind:key="'e-'+e">{{ error }}</li></ul> -->
                </p>
            </div>
            <div class="section mb-5 p-2">
                <form @submit.prevent="checkForm">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="passwordC">Contraseña actual</label>
                                    <input type="password" class="form-control" id="passwordC" autocomplete="off" placeholder="Su contraseña" v-model="currentPass" required />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="password1">Contraseña</label>
                                    <input type="password" class="form-control" id="password1" autocomplete="off" placeholder="Su contraseña" v-model="password" required />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="password2">Contraseña de nuevo</label>
                                    <input type="password" class="form-control" id="password2" autocomplete="off" placeholder="Ingrese la contraseña de nuevo" v-model="passwordC" required />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-button-group transparent">
                        <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="sending">Actualizar</button>
                    </div>
                </form>
            </div>
        </div>
        <!-- * Cápsula de la Aplicación -->

    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            sending: false,
            currentPass: null,
            password: null,
            passwordC: null,
            errors: [],
        };
    },
    mounted() {
        this.$root.loadBackButtom();
        this.$root.loadInputs();
    },
    methods: {
        ...mapActions(['v1_updatePasswordAPI', 'newNotification']),
        async checkForm() {
            this.sending = true;
            if (this.password && this.passwordC) {
                const result = await this.v1_updatePasswordAPI({ password:this.currentPass, new_password:this.password });
                // if (result == true) this.$router.push({name:'login'})
                if (result == true) {
                    this.newNotification({
                        type: 'success',
                        title: 'Actualizacion con exito!',
                        message: "Su contraseña se a cambiado con exito.",
                    })
                    location.replace('/')
                }
            } else {
                this.newNotification({
                    type: 'danger',
                    title: 'Error',
                    message: "Error actualizando la contraseña de acceso.",
                })
            }
            this.sending = false;
        }
    }
}
</script>